export class ListGdsgObjectsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "commonPrefixes",
            "baseName": "commonPrefixes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "objects",
            "baseName": "objects",
            "type": "Array<GdsgObjectEntry>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGdsgObjectsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
